export enum ScreenEnum {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export type ScreenModeType = {
  screen?: ScreenEnum
  screenHeight?: number
  screenWidth?: number
}
